import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import trainTime from '../../../lib/TrainTime';
import MomentPropTypes from "../../../helpers/MomentPropTypes";
import Timeband from '../../../records/Timeband';
import TrackingActions from "../../../actions/TrackingActions";
import { JourneyDirections, widgetSearchElements } from "../../../constants/AppConstants";

import Calendar from '../../form/Calendar';
import TimeSelector from './TimeSelector';
import PureRenderComponent from '../../PureRenderComponent';
import ArriveDepart from './ArriveDepart';


class TimebandSelector extends PureRenderComponent {

    static propTypes = {
        name: PropTypes.string,
        timeband: PropTypes.instanceOf(Timeband),
        min: MomentPropTypes.isMoment,
        max: MomentPropTypes.isMoment,
        onChange: PropTypes.func
    };

    static defaultProps = {
        name: 'timeband',
        timeband: new Timeband(),
        onChange: _.noop
    };

    handleChangeFor = (field, trackingEvent) => (value) => {
        const { onChange, timeband, name } = this.props;
        if (trackingEvent === widgetSearchElements.timeSelector) {
            TrackingActions.widgetSearchClick({ name: (name === JourneyDirections.OUTWARD) ? 'outbound-time' : 'return-time', value });
        } else if (trackingEvent === widgetSearchElements.arriveDepart) {
            TrackingActions.widgetSearchClick({ name: (name === JourneyDirections.OUTWARD) ? 'outbound-arrive-depart' : 'return-arrive-depart', value });
        }
        onChange(timeband.set(field, value));
    };

    handleDateChange = (date) => {
        const { timeband, name } = this.props;
        const covertedDate = trainTime(date.format('YYYY-MM-DD'));

        TrackingActions.widgetDaySelect({ date: date, type: (name === JourneyDirections.OUTWARD) ? 'outbound' : 'return' });

        const datetime = covertedDate.clone().set({
            hour: timeband.datetime.hour(),
            minute: timeband.datetime.minute()
        });

        this.handleChangeFor('datetime')(datetime);
    };


    handleArriveDepartChange = (arriveDepart) => {
        this.props.onChange(this.props.timeband.set('arriveDepart', arriveDepart));
    };

    render () {
        const { name, min, max, timeband } = this.props;
        const { datetime, arriveDepart } = timeband;

        return (
            <div className="clearfix timeband">
                <Row>
                    <Col xs={12} sm={6} className="margin-bottom">
                        <Calendar id={ name + '-date' }
                            selected={ datetime }
                            onChange={ this.handleDateChange }
                            min={ min }
                            max={ max }
                            className="timeband__calendar"/>
                    </Col>
                    <Col xs={ 6 }>
                        <ArriveDepart arriveDepart={ arriveDepart }
                            onChange={ this.handleChangeFor('arriveDepart', widgetSearchElements.arriveDepart) }
                            direction={ name }
                            className="margin-bottom--sm"/>
                    </Col>
                    <Col xs={ 6 }>
                        <TimeSelector className="timeband__time"
                            datetime={ datetime }
                            onChange={ this.handleChangeFor('datetime', widgetSearchElements.timeSelector) } />
                    </Col>
                </Row>
            </div>
        );
    }

}


export default TimebandSelector;



// WEBPACK FOOTER //
// ./src/components/search/dates/TimebandSelector.js